import { axiosInstance } from '../../config/http';

export const getUserInfo = async (token: string) => {
  const res = await axiosInstance.get(`/usr/users/info`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return res;
};

export const getAllProjectsOfCurrentUser = async () => {
  return axiosInstance.get(`prj/projects/projects`);
};

export const generatePasswordChangeLink = async () => {
  const res = await axiosInstance.get(`usr/Users/generate-token`);
  return res;
};
